module.exports = __webpack_public_path__ + "static/media/notepencil.e0cacd12.png";